export const isProbablyMobile = () => {
    if (typeof navigator === 'undefined') {
        return false;
    }
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const isInPhantom = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    const ua = navigator.userAgent || '';
    return /Phantom/i.test(ua) || Boolean(window.phantom?.solana?.isPhantom || window.solana?.isPhantom);
};

export const isInSolflare = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    const ua = navigator.userAgent || '';
    return /Solflare/i.test(ua) || Boolean(window.solflare?.isSolflare);
};

export const isInBinance = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    const ua = navigator.userAgent || '';
    return Boolean(window.isBinance)
        || Boolean(window.binancew3w)
        || /BNC\/|Binance/i.test(ua);
};

export const getBinanceSolanaProvider = () => {
    if (typeof window === 'undefined') {
        return null;
    }
    const candidates = [
        window.binancew3w?.solana,
        window.binanceSolana,
        window.bnSolana
    ];
    const injected = candidates.find((provider) => provider && typeof provider.connect === 'function');
    if (injected) {
        return injected;
    }
    if (
        isInBinance()
        && window.solana
        && typeof window.solana.connect === 'function'
        && !window.solana.isPhantom
        && !window.solflare
    ) {
        return window.solana;
    }
    return null;
};

export const isInWalletBrowser = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    const ua = navigator.userAgent || '';
    return isInPhantom()
        || isInSolflare()
        || isInBinance()
        || /Trust/i.test(ua)
        || /Backpack/i.test(ua)
        || /MagicEden|Magic Eden/i.test(ua)
        || Boolean(window.ethereum?.isMetaMask && /Mobile/i.test(ua));
};

export const currentPageUrl = () => (typeof window === 'undefined' ? '' : window.location.href);
export const currentOrigin = () => (typeof window === 'undefined' ? '' : window.location.origin);

export const phantomBrowseUrl = (href = currentPageUrl()) => {
    const url = encodeURIComponent(href);
    const ref = encodeURIComponent(currentOrigin());
    return `https://phantom.app/ul/browse/${url}?ref=${ref}`;
};

export const solflareBrowseUrl = (href = currentPageUrl()) => {
    const url = encodeURIComponent(href);
    const ref = encodeURIComponent(currentOrigin());
    return `https://solflare.com/ul/v1/browse/${url}?ref=${ref}`;
};

export const trustBrowseUrl = (href = currentPageUrl()) => (
    `https://link.trustwallet.com/open_url?coin_id=501&url=${encodeURIComponent(href)}`
);

export const backpackBrowseUrl = (href = currentPageUrl()) => (
    `https://backpack.app/ul/v1/browse/${encodeURIComponent(href)}`
);

const toBase64 = (value) => {
    if (typeof btoa === 'function') {
        return btoa(value);
    }
    return Buffer.from(value, 'binary').toString('base64');
};

export const binanceBrowseUrl = (href = currentPageUrl()) => {
    const startPagePath = toBase64('/pages/browser/index');
    const startPageQuery = toBase64(`url=${href}`);
    const deeplink = `bnc://app.binance.com/mp/app?appId=yFK5FCqYprrXDiVFbhyRx7&startPagePath=${startPagePath}&startPageQuery=${startPageQuery}`;
    return `https://app.binance.com/en/download?_dp=${toBase64(deeplink)}`;
};

export const WALLET_MODAL_OPEN_DELAY_MS = 350;

export const openWalletPicker = ({ select, setVisible }) => {
    if (typeof select === 'function') {
        select(null);
    }
    window.setTimeout(() => setVisible(true), WALLET_MODAL_OPEN_DELAY_MS);
};
